var map = {
	"./Community_Care_C1.pdf": 1324,
	"./Community_Care_C2.pdf": 1325,
	"./Community_Care_C3.pdf": 1326,
	"./Community_Care_C4.pdf": 1327,
	"./Community_Care_C5.pdf": 1328,
	"./Community_Care_E1.pdf": 1329,
	"./VDVMNAEN0417_Assessing_Violence_in_the_Community_-_A_Handbook_for_the_Workplace_V2.0_04.26.2017.pdf": 1330
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1334;



//////////////////
// WEBPACK FOOTER
// ./public/assets/pdfs ^\.\/.*$
// module id = 1334
// module chunks = 0